import React from "react";
import HeaderTitle from "app/header/parts/HeaderTitle";
import ErrorBoundary from "lib/ErrorBoundary";
import useIsMobile from "lib/hooks/useIsMobile";
import { useIsPublicPage } from "lib/routing";
import { Nav, Navbar } from "react-bootstrap";
import { useSelector } from "react-redux";
import { MenuDataProvider } from "../menuFilterBar/parts/menuDataProvider";
import { MenuFilterBar } from "../menuFilterBar/MenuFilterBar";
import { PreferencesDialog } from "../../../components/PreferencesDialog/PreferencesDialog";
import { isAssetClassOrHomePage } from "../../../components/PreferencesDialog/redesignUtils";
import { AssetClassBar } from "./desktop/DesktopHeaderParts/DesktopHeaderParts";
import { TopLinksBar } from "./desktop/TopLinksBar/TopLinksBar";
import { MobileMenu, MobileMenuButton } from "./mobile/MobileMenu";

import "./headerRedesign.css";

export function Header({ style, chatOpen, panelWidth, chatFullscreen }) {
  const isPublic = useIsPublicPage();
  const isMobile = useIsMobile();

  if (isPublic) return null;

  return (
    <ErrorBoundary>
      <MenuDataProvider>
        {isMobile ? <MobileHeader /> : <DesktopHeader style={style} chatOpen={chatOpen} panelWidth={panelWidth} chatFullscreen={chatFullscreen} />}
      </MenuDataProvider>
      <PreferencesDialog chatOpen={chatOpen} panelWidth={panelWidth} />
    </ErrorBoundary>
  );
}

export function DesktopHeader({ style, chatOpen, panelWidth, chatFullscreen }) {
  const fixedStyle = {
    ...style,
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: chatOpen && !chatFullscreen ? 30 : 5,
  };

  return (
    <>
      <header style={fixedStyle}>
        <TopLinksBar />
        <AssetClassBar />
        {isAssetClassOrHomePage() && <MenuFilterBar chatOpen={chatOpen} panelWidth={panelWidth} />}
      </header>
      {isAssetClassOrHomePage() ? (
        <div className="header-spacer" />
      ) : (
        <div className="header-spacer-landing" />
      )}
    </>
  );
}

export function MobileHeader() {
  const menuBtnPosition = useSelector((state) => state.preferences["grp-menu-side"][0]);
  const isMenuBtnPositionLeft = menuBtnPosition === "Left";
  return (
    <>
      <Navbar bg="primary" variant="dark" expand="md" className="flex-nowrap mb-3">
        <Nav className="flex-row w-100">
          {isMenuBtnPositionLeft && <MobileMenuButton />}
          <HeaderTitle />
          {!isMenuBtnPositionLeft && <MobileMenuButton />}
        </Nav>
        <MobileMenu />
      </Navbar>
      {isAssetClassOrHomePage() && <MenuFilterBar />}
    </>
  );
}
